import React from "react";
import styled from "styled-components";
import {isMobile} from 'react-device-detect';

import Container from "./container"

import sbcsLogo from "../images/sbcsblack.png"
import muLogo from "../images/mu.gif"
import camLogo from "../images/cam.png"

const Footer = styled.footer`
    background-color: white;
    position: relative;
    z-index: 1;
    top: -50px;

    > div {
        margin-top: 50px;
        display: ${isMobile ? "block":"flex"};
        justify-content: space-between;
        gap: 20px;    
        padding: 30px;
    }

    &:before {
        background: inherit;
        top: 0;
        content: '';
        display: block;
        height: 70%;
        left: 0;
        position: absolute;
        right: 0;
        transform: skewY(2.5deg);
        transform-origin: 100%;
        z-index: -1;
    }

    a {
        text-decoration: none;
    }
`
const Copyright = styled.div`
    color: #666;
    padding: 0px 25px 10px 25px;
    font-size: 85%;
    text-align: ${isMobile ? "center":"left"};
`

function SiteFooter(props) {

  return (
    <>
        {/* <Container> */}
            <Footer>
                <div>
                    <div style={{
                        display: "flex",
                        gap: "15px",
                        alignItems: "center",
                        justifyContent: isMobile ? "space-between":"normal",
                    }}>
                        <a href="http://www.marshall.edu/" target="_blank">
                            <img src={muLogo} alt="Marshall University" width="150" />
                        </a>
                        <a href="http://www.marshall.edu/cofa/" target="_blank">
                            <img src={camLogo} alt="Marshall College Of Arts & Media" width="100" />
                        </a>
                    </div>
                    <div>
                        <div>
                            <div style={{
                                display: "flex",
                                flexFlow: isMobile ? "wrap": "unset",
                                gap: "10px",
                                alignItems: "center",
                                justifyContent: isMobile ? "unset" : "flex-end",
                                color: "black",
                                marginTop: (isMobile ? 50:0)+"px",
                                marginBottom: "25px",
                            }}>
                                <img 
                                    src={process.env.PUBLIC_URL + "/sponsors/wv_division_of_culture_history.jpg?v7"} 
                                    alt="WV Division of Culture & History"
                                    height="45"
                                />
                                <img 
                                    src={process.env.PUBLIC_URL + "/sponsors/wv_department_of_education.jpg?v7"} 
                                    alt="WV Department of Education"
                                    height="45"
                                />
                                <img 
                                    src={process.env.PUBLIC_URL + "/sponsors/village_caregiving.jpg?v7"} 
                                    alt="Village Caregiving"
                                    height="25"
                                />
                                <img 
                                    src={process.env.PUBLIC_URL + "/sponsors/encova.jpg?v7"} 
                                    alt="Encova"
                                    height="45"
                                /> 
                                <div style={{
                                    fontSize: "90%",
                                    border: "1px solid #ccc",
                                    borderRadius: "5px",
                                    padding: "10px",
                                }}>
                                    Cabell County Commission
                                </div>
                            </div>
                            <div style={{
                                display: "flex",
                                flexFlow: isMobile ? "wrap": "unset",
                                gap: "10px",
                                alignItems: "center",
                                justifyContent: isMobile ? "unset" : "flex-end",
                                color: "black",
                                marginTop: (isMobile ? 50:0)+"px",
                            }}>
                                <div style={{
                                    fontSize: "80%",
                                    border: "1px solid #ccc",
                                    borderRadius: "5px",
                                    padding: "10px",
                                }}>
                                    Anonymous
                                </div>                                
                                <img 
                                    src={process.env.PUBLIC_URL + "/sponsors/wsaz.jpg?v7"} 
                                    alt="WSAZ"
                                    height="25"
                                /> 
                                <img 
                                    src={process.env.PUBLIC_URL + "/sponsors/herald_dispatch.jpg?v7"} 
                                    alt="Herald Dispatch"
                                    height="25"
                                /> 
                                <img 
                                    src={process.env.PUBLIC_URL + "/sponsors/iheartradio.jpg?v7"} 
                                    alt="iHeart Media"
                                    height="25"
                                />  
                                <a href="https://www.sbcs.com/" target="_blank">
                                    <img src={sbcsLogo} alt="Strictly Business Computer Systems" height="35" />
                                </a>                                                                                           
                            </div>
                        </div>
                    </div>
                </div>
            </Footer>
        {/* </Container>  */}
        <Container nopadding={true}> 
            <Copyright>© 2001-2024 Marshall Artists Series</Copyright>
        </Container> 
    </>
  );
}

export default SiteFooter;